import React from "react";
import JoinOurTeam from "./careersComponents/careersFirstPage/JoinOurTeam.jsx";
import CareerCard from "./careersComponents/CareerDataCard/CareerCard.jsx";
import { useLocation } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Careers = () => {
  //  const query = useQuery();
  // const selectedTab = query.get("tab") || "careers";
  const location = useLocation();
  const selectedTab = location.state?.selectedTab || "careers";

  // React.useEffect(() => {
  //   console.log("Selected Tab:", selectedTab);
  //   }, [selectedTab]);
  return (
    <>
      <JoinOurTeam />
      <CareerCard selectedTab={selectedTab} />
    </>
  );
};

export default Careers;
